import React, { createContext, useState, useContext } from 'react';

interface CookieProviderProps {
  children: React.ReactNode;
}

interface CookieContextType {
  cookie: string;
  setCookie: (cookie: string) => void;
}

const CookieContext = createContext({
  cookie: '',
  setCookie: () => {
    return;
  },
} as CookieContextType);

export const CookieProvider = ({ children }: CookieProviderProps): React.ReactElement => {
  const [cookie, setCookie] = useState<string>('');

  return <CookieContext.Provider value={{ cookie, setCookie }}>{children}</CookieContext.Provider>;
};
export const useCookieContext = () => useContext(CookieContext);
